// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"play-rectangle"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2 4H22V20H2V4Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M15.75 11.9997L9 15.8968L9 8.10254L15.75 11.9997Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2 4H22V20H2V4Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15.75 11.9997L9 15.8968L9 8.10254L15.75 11.9997Z","strokeWidth":"props.strokeWidth"}}]}]};

const PlayRectangleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'play-rectangle',
    ref,
    icon: element,
  },
));

PlayRectangleIcon.displayName = 'PlayRectangleIcon';

export default PlayRectangleIcon;
